package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class SystemConfigResponse(
    val id: String,
    val key: String,
    val value: Int,
    val changeSummaryEn: String? = null,
    val changeSummaryEs: String? = null,
    val isCritical: Boolean = false,
    val effectiveDate: Long = 0L
)
